import Vue from 'vue'
import App from './PApp.vue'

Vue.config.productionTip = false

import anime from 'animejs'
import router from './router'

window.anime = anime;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
